import moment from 'moment';
import 'moment/locale/ca';
import 'moment/locale/cy';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';

import { getLocale } from '../Translate';

const stringFormat = 'YYYY-MM-DD HH:mm:ss';

const DateUtils = {};

DateUtils.timeFormat = 'HH:mm';

DateUtils.setTimeFormatFromAccount = (accountTimeFormat) => {
	DateUtils.timeFormat = accountTimeFormat === 'g:i A' ? 'h:mma' : 'HH:mm';
};

DateUtils.setLocale = (locale) => {
    moment.locale(locale || getLocale());
};

DateUtils.eventTimezone = null;

DateUtils.setTimezone = (timezone) => {
    return DateUtils.eventTimezone = timezone;
};

DateUtils.now = () => moment.utc().format(stringFormat);

DateUtils.utcNow = () => Number(moment().format('X'));

// Formatting Helpers
DateUtils.year = (date) => moment.utc(date, stringFormat).format('YYYY'); // 2000
DateUtils.month = (date) => moment.utc(date, stringFormat).format('MMM'); // Jan
DateUtils.day = (date) => moment.utc(date, stringFormat).format('DD'); // 1
DateUtils.dayMonth = (date) => moment.utc(date, stringFormat).format('Do MMMM'); // 1st January
DateUtils.dayMonthYear = (date) => moment.utc(date, stringFormat).format('Do MMMM YYYY'); // 1st January 2020
DateUtils.dayMonthYearHourMinute = (date) => moment.utc(date, stringFormat).format(`Do MMMM YYYY ${DateUtils.timeFormat}`); // 1st January 2020 {timeFormat}
DateUtils.hour = (date) => moment.utc(date, stringFormat).format('HH'); //09
DateUtils.minute = (date) => moment.utc(date, stringFormat).format('mm'); //00
DateUtils.hourMinute = (date) => moment.utc(date, stringFormat).format(`${DateUtils.timeFormat}`); //{timeformat}
DateUtils.dayDateMonth = (date) => moment.utc(date, stringFormat).format('ddd D MMM'); // Mon 14 Dec
DateUtils.dayMonthDateYear = (date) => moment.utc(date, stringFormat).format('dddd, MMMM Do YYYY'); // Monday, December 14th 2020
DateUtils.dateMonthYearHourMinute = (date) => moment.utc(date, stringFormat).format(`Do MMM YYYY, ${DateUtils.timeFormat}`); //14th Jan 2021, {timeFormat}

// Date Comparison
DateUtils.isSameDay  = (start, end) => DateUtils.dayMonthYear(start) === DateUtils.dayMonthYear(end);
DateUtils.isSameHour = (start, end) => DateUtils.hourMinute(start) === DateUtils.hourMinute(end);

DateUtils.renderStartDateEndDate = (start, end, seperator = 'to') => {
    if (DateUtils.isSameDay(start, end)) {
        return DateUtils.dayMonthYear(start);
    }
    return `${DateUtils.dayMonthYear(start)} ${seperator} ${DateUtils.dayMonthYear(end)}`;
}

DateUtils.renderStartTimeEndTime = (start, end, seperator = 'to') => {
    if (DateUtils.isSameHour(start, end)) {
        return DateUtils.hourMinute(start);
    }
    return `${DateUtils.hourMinute(start)} ${seperator} ${DateUtils.hourMinute(end)}`;
}

DateUtils.renderStartDateTimeEndDateTime = (start, end, separator = 'to') => {
    if (DateUtils.isSameDay(start, end)) {
        return `${DateUtils.dateMonthYearHourMinute(start)} ${separator} ${DateUtils.hourMinute(end)}`;
    }
    return `${DateUtils.dateMonthYearHourMinute(start)} ${separator} ${DateUtils.dateMonthYearHourMinute(end)}`;
}

window.DateUtils = DateUtils;

export default DateUtils;